import React, { Component } from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import FooterComponent from './FooterComponent'

import Signup from '../Form/Signup'

// core components
import GridContainer from '../Grid/GridContainer.jsx'
import GridItem from '../Grid/GridItem.jsx'

import BNLogo from '../../assets/img/BNFooterLogo.svg'

import { OutboundLink } from 'gatsby-plugin-google-analytics'

import styles from '../../assets/jss/material-kit-pro-react/views/componentsSections/footerStyle.jsx'

import cdnflag from '../../assets/img/cdn.svg'

class SectionFooter extends Component {
  render() {
    const { classes } = this.props

    return (
      <FooterComponent
        theme="dark"
        big
        content={
          <div className={classes.section}>
            <div className={classes.footer}>
              <GridContainer>
                <GridItem xs={12} sm={3} md={3}>
                  <Link to="/">
                    <FooterLogo src={BNLogo} alt="Bitnational Logo" />
                  </Link>
                  <p>
                    OWNED AND OPERATED IN CANADA&nbsp;&nbsp;
                    <img
                      className={classes.cdnimage}
                      src={cdnflag}
                      alt=""
                      role="icon"
                    />
                  </p>
                </GridItem>
                <GridItem xs={12} sm={2} md={2}>
                  <h5>About Us</h5>
                  <ul className={classes.linksVertical}>
                    <li>
                      <Link to="/whoweare">Who We Are</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact</Link>
                    </li>
                  </ul>
                </GridItem>
                <GridItem xs={12} sm={2} md={2}>
                  <h5>Services</h5>
                  <ul className={classes.linksVertical}>
                    <li>
                      <Link to="/locations#catm">CATM</Link>
                    </li>
                    <li>
                      <Link to="/locations#branches">Branches</Link>
                    </li>
                    <li>
                      <a href="https://exchange.bitnational.com/?login=true">
                        Exchange
                      </a>
                    </li>
                    <li>
                      <Link to="/fees/catm">Fees</Link>
                    </li>
                  </ul>
                </GridItem>
                <GridItem xs={12} sm={2} md={2}>
                  <h5>Docs</h5>
                  <ul className={classes.linksVertical}>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/terms-of-use">Terms of Use</Link>
                    </li>
                    <li>
                      <Link to="/kyc-policy">KYC Policy</Link>
                    </li>
                    <li>
                      <Link to="/aml-policy">AML Policy</Link>
                    </li>
                    <li>
                      <OutboundLink
                        target="_blank"
                        href="//bitnationalinc.github.io/api/"
                      >
                        API
                      </OutboundLink>
                    </li>
                  </ul>
                </GridItem>
                <GridItem xs={12} sm={3} md={3}>
                  <h5>Stay up to Date</h5>
                  <p>
                    Join our newsletter and get news in your inbox every week!
                    We hate spam too and will never send you any.
                  </p>
                  <Signup white />
                </GridItem>
              </GridContainer>
            </div>
          </div>
        }
      />
    )
  }
}

const FooterLogo = styled.img`
  max-width: 250px;
  margin-bottom: 1rem;
`

export default withStyles(styles)(SectionFooter)



// WEBPACK FOOTER //
// ./src/components/Footer/SectionFooter.jsx